import React from 'react';
import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { selectLayoutType } from '~src/spacesPlatform/selectors/LayoutTypeSelector';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { LeftNav, LeftNavProps } from './LeftNav';

const mapStateToProps: MapStateToProps<LeftNavProps> = (state: AppState) => ({
  isInVizViewerArea: NavLocationSelectors.inVizViewerArea(state),
  layoutType: selectLayoutType(state)
});

export const ConnectedLeftNav: React.ComponentClass =
  connect(mapStateToProps)(LeftNav);
